const colors = {
    brand: {
      primary: {
        light: '#C8553D',   // terracotta
        dark: '#E07A65',
        shade: '#A0432F',   // darker terracotta for depth accents
        rgb: {
          light: '200, 85, 61',
          dark: '224, 122, 101',
        },
      },
      secondary: {
        light: '#4A7C59',   // forest green
        dark: '#6BAE80',
        rgb: {
          light: '74, 124, 89',
          dark: '107, 174, 128',
        },
      },
      success: {
        light: '#4A7C59',
        dark: '#6BAE80'
      }
    },
    background: {
      light: '#FFFCF5',           // warm parchment
      dark: '#221E19',            // deep peat
      translucentLight: 'rgba(255, 252, 245, 0.85)',
      translucentDark: 'rgba(28, 24, 20, 0.88)'
    },
    surface: {
      light: '#FAF7F0',           // slightly darker parchment for cards
      dark: '#2A2520',
      translucentLight: 'rgba(250, 247, 240, 0.6)',
      translucentDark: 'rgba(255, 255, 255, 0.04)'
    },
    border: {
      light: '#E4D9C8',           // warm tan
      dark: '#3D3529',            // warm dark border
      hover: '#C8553D'            // terracotta on hover
    },
    text: {
      primary: {
        light: '#2D2116',         // deep warm brown
        dark: '#F2EDE4'           // warm off-white
      },
      secondary: {
        light: '#7A6652',         // muted warm brown
        dark: '#A0917E'
      }
    },
    neutral: {
      cream: '#FFFCF5',            // near-white stroke/fill for dark-on-accent detail
      rgb: {
        black: '0, 0, 0',
        white: '255, 255, 255',
      },
    },
    gradients: {
      title: {
        light: 'linear(to-r, #C8553D, #4A7C59)',
        dark: 'linear(to-r, #E07A65, #6BAE80)'
      }
    }
  };

  export default colors;
